import script from "./TravelForBeginners.vue?vue&type=script&lang=ts&setup=true"
export * from "./TravelForBeginners.vue?vue&type=script&lang=ts&setup=true"

import "./TravelForBeginners.vue?vue&type=style&index=0&id=2aef0517&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2aef0517"]])

export default __exports__